import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Input from '../input';

class NewPassPopup extends Component {
  static propTypes = {
    route: PropTypes.string.isRequired,
  };

  state = {
    loading: false,
    error: null,
    password: '',
    password_confirm: '',
  };

  confirm = e => {
    const { password, password_confirm } = this.state;
    const { route } = this.props;
    e.preventDefault();

    let formData = new FormData(this.form);

    const headers = {
      method: 'POST',
      body: formData,
      headers: {},
    };

    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    }

    this.setState({
      loading: true,
      error: null,
    });

    const isValid = () => {
      const result = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).*$/.test(
        password,
      );
      return result;
    };

    if (password.trim() === '' || password_confirm.trim() === '') {
      this.setState({ loading: false, error: 'Заполните все поля' });
      return false;
    }

    if (password === password_confirm) {
      switch (isValid()) {
        case false:
          this.setState({
            loading: false,
            error: 'Пароль не соответствует требованиям',
          });
          break;
        default:
          // send data
          fetch(route, headers)
            .then(response => response.json())
            .then(json => {
              if (json.status == 'success') {
                document.location.href = '/profile/settings';
              } else if (json.status == 'error') {
                this.setState({
                  loading: false,
                  error: json.errors.message,
                });

                this.showPopup(
                  'error',
                  json.errors.message ||
                    'Что-то пошло не так. Попробуйте еще раз.',
                );
              }
            })
            .catch(error => {
              this.setState({
                loading: false,
              });

              this.showPopup(
                'error',
                `Что-то пошло не так: ${error}. Попробуйте еще раз.`,
              );
            });
          break;
      }
    } else {
      this.setState({ loading: false, error: 'Пароли не совпадают' });
    }
  };

  // Вывод попапа с ошибкой
  showPopup(status, message, func) {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = 'mfp-anim';
        },
        open: function() {
          render(
            <Popup
              type="alert"
              status={status}
              title={status == 'success' ? 'Отлично!' : 'Ошибка'}
              message={message}
              button="Назад в профиль"
              func={func}
            />,
            $('#popup')[0],
          );
        },
        close: function() {
          remove($('#popup')[0]);
        },
      },
    });
  }

  render() {
    const { loading, error, password, password_confirm } = this.state;

    const formBody = (
      <div className="inp-group">
        <div className="row">
          <div className="inp-group__case">
            <Input
              value={password}
              label="Пароль"
              name="password"
              password
              onChange={val => this.setState({ password: val })}
            />
          </div>
          <div className="inp-group__case">
            <Input
              value={password_confirm}
              label="Подтвердите пароль"
              name="password-confirm"
              password
              onChange={val => this.setState({ password_confirm: val })}
            />
          </div>
        </div>
      </div>
    );

    let btnClasses = ['btn'];

    if (loading) btnClasses.push('btn--loading');

    return (
      <div className="popup" data-type="password">
        <div className="popup__aside">
          <div className="card-popup__pic" />
        </div>
        <form
          className="popup__content"
          ref={node => (this.form = node)}
          onSubmit={this.confirm}
        >
          <div className="popup__content-inner">
            <div className="popup__section-title">
              <h3 className="heading heading--1 popup__title">
                Придумайте пароль
              </h3>
              <p className="popup__text">
                С этим паролем вы сможете входить не дожидаясь СМС-кода. Пароль
                должен состоять как минимум из{' '}
                <span className="popup__text--accent">6 символов</span>,
                содержать по крайней мере{' '}
                <span className="popup__text--accent">
                  одно число, одну заглавную и одну строчную букву.
                </span>
              </p>
            </div>
            {formBody}
            <div className="popup__btn-wrap">
              {error ? <p className="popup__text">{error}</p> : null}
              <div className="wrap">
                <button className={btnClasses.join(' ')} type="submit">
                  Сохранить пароль
                </button>
              </div>
            </div>
          </div>
        </form>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
          </svg>
        </button>
      </div>
    );
  }
}

export default NewPassPopup;
